import React, {useCallback} from "react";
import {setAtPath} from "../shared/pathUpdate";

import ProjectSettings from "./ProjectSettings";
import PartsEditor from "./PartsEditor";

export default function ProjectEditor({
                                          contentJson,
                                          setContentJson
                                      }) {

    const updateAtPath = useCallback((path, value) => {

        setContentJson(prev =>
            setAtPath(prev, path, value)
        );

    }, [setContentJson]);

    if (!contentJson) {
        return <div className="p-8">No project loaded.</div>;
    }

    return (

        <div className="flex flex-col gap-10">

            <ProjectSettings
                project={contentJson}
                updateAtPath={updateAtPath}
            />

            <PartsEditor
                project={contentJson}
                path={[]}
                updateAtPath={updateAtPath}
            />

        </div>

    );

}